
import { createContext, Dispatch, ReactElement, useContext, useReducer } from "react"
import { Action, initialState } from "./SignupReducer"
import { SignupState } from "./SignupState"

interface StoreProviderProps {
    children: ReactElement
    initialState: SignupState
    reducer: (state: SignupState, action: Action) => SignupState
}

const SignupStore = createContext<[SignupState, Dispatch<Action>]>([initialState, () => { null }])

SignupStore.displayName = `SignupStore`

export const useSignupStore = () => useContext(SignupStore)

export const StoreProvider = (props: StoreProviderProps) => {
    const { children, initialState, reducer } = props
    const [globalState, dispatch] = useReducer(reducer, initialState)

    return (
        <SignupStore.Provider value={[globalState, dispatch]}>{children}</SignupStore.Provider>
    )
}